import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c6d2740"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "100vh",
  class: "d-flex flex-column flex-lg-row-reverse"
}
const _hoisted_2 = { class: "mt-n36" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white lg:text-indigo-500 text-3xl" }, "Login", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-white lg:text-indigo-500 text-2x1" }, "Faça o Login", -1))

import { SignupForm, LoginForm, ResetPasswordForm } from '../components'
import { WelcomeMode } from '@/@types'
import { useDisplay } from 'vuetify'
interface Props {
  mode?: WelcomeMode
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    mode: { default: 'login' }
  },
  setup(__props: any) {

const props = __props as { mode: WelcomeMode }

const { mdAndDown, lgAndUp } = useDisplay()



return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, {
      width: _unref(lgAndUp) ? '65vw' : '',
      height: _unref(mdAndDown) ? '40vh' : '100vh',
      rounded: _unref(mdAndDown) ? 'b-lg' : false,
      id: "banner",
      color: "primary"
    }, null, 8, ["width", "height", "rounded"]),
    _createVNode(_component_v_sheet, {
      class: "d-flex flex-column justify-center align-center flex-grow-1",
      id: "blank"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_v_card, {
            rounded: "",
            color: _unref(mdAndDown) ? 'white' : 'transparent',
            class: _normalizeClass([_unref(mdAndDown) ? 'elevation-10' : 'elevation-0', "pa-3 pa-lg-16"]),
            "min-width": "340px"
          }, {
            default: _withCtx(() => [
              (props.mode === 'signup')
                ? (_openBlock(), _createBlock(_unref(SignupForm), { key: 0 }))
                : _createCommentVNode("", true),
              (props.mode === 'login')
                ? (_openBlock(), _createBlock(_unref(LoginForm), { key: 1 }))
                : _createCommentVNode("", true),
              (props.mode === 'reset')
                ? (_openBlock(), _createBlock(_unref(ResetPasswordForm), { key: 2 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["color", "class"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})